import EventBus from '@/plugins/EventBus';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export default class ImageGallery extends Plugin {
  public init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('insertImage', (locale: any) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Insert gallery',
        icon: imageIcon,
        tooltip: true,
      });

      // Callback executed once the image is clicked.
      view.on('execute', () => {
        EventBus.$once('gallery:select', (url: string) =>
          this.insertImage(url),
        );
        EventBus.$emit('gallery:show');
      });

      return view;
    });
  }

  public insertImage(imageUrl: string) {
    const editor = this.editor;

    editor.model.change((writer: any) => {
      const imageElement = writer.createElement('image', {
        src: imageUrl,
      });

      // Insert the image in the current selection location.
      editor.model.insertContent(imageElement, editor.model.document.selection);
    });
  }
}
